import React from 'react';
import Section from '../layout/Section';
import SectionTitle from '../ui/SectionTitle';
import PricingCard from '../ui/PricingCard';
import StaggerContainer from '../animations/StaggerContainer';
import ScrollReveal from '../animations/ScrollReveal';
import { pricingPlans, discountTiers } from '../../data/pricing';

export default function PricingSection() {
  return (
    <Section id="pricing">
      <SectionTitle
        title="Des tarifs simples et transparents"
        subtitle="Choisissez la formule adaptée à votre commerce"
      />
      <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch max-w-5xl mx-auto">
        {pricingPlans.map((plan, i) => (
          <PricingCard key={i} plan={plan} index={i} />
        ))}
      </StaggerContainer>

      {/* Discount table */}
      <ScrollReveal className="mt-10 sm:mt-14">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-center text-xl sm:text-2xl font-bold text-text-dark mb-6">
            Économisez avec un engagement plus long
          </h3>
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-50 border-b border-gray-100">
                    <th className="text-left px-4 py-3 font-semibold text-text-dark">Durée</th>
                    <th className="text-right px-4 py-3 font-semibold text-text-dark">Standard</th>
                    <th className="text-right px-4 py-3 font-semibold text-text-dark">Premium</th>
                    <th className="text-right px-4 py-3 font-semibold text-text-dark">Économie</th>
                  </tr>
                </thead>
                <tbody>
                  {discountTiers.map((tier, i) => (
                    <tr
                      key={tier.duration}
                      className={i < discountTiers.length - 1 ? 'border-b border-gray-50' : ''}
                    >
                      <td className="px-4 py-3 font-medium text-text-dark">{tier.duration}</td>
                      <td className="px-4 py-3 text-right text-text-dark">{tier.standard} FCFA</td>
                      <td className="px-4 py-3 text-right text-text-dark">{tier.premium} FCFA</td>
                      <td className="px-4 py-3 text-right">
                        {tier.saving ? (
                          <span className="inline-block bg-green-100 text-green-700 text-xs font-semibold px-2 py-0.5 rounded-full">
                            -{tier.saving} FCFA
                          </span>
                        ) : (
                          <span className="text-text-gray">—</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <p className="text-center text-text-gray text-xs mt-3">
            Période de grâce de 7 jours après expiration
          </p>
        </div>
      </ScrollReveal>
    </Section>
  );
}
